import { getSuperMoneyAccountId } from "External-API-modules/Controller/Axis/Utils/functions";
import AnalyticsManager, { Platform } from "sm-analytics-sdk";

const initTracking = (): void => {
  AnalyticsManager.init(Platform.React, {
    apiKey: process.env.REACT_APP_SM_ANALYTICS_API_KEY || "",
    enableLogs: true,
    autoFlushEventsOnUnload: true,
    shouldAppendGenericEventProperties: true,
  });
};

const trackEvent = (eventName: string, data: Record<string, unknown> = {}): void => {
  const superMoneyAccountId = getSuperMoneyAccountId();
  AnalyticsManager.setUserId(superMoneyAccountId || "");
  AnalyticsManager.track({
    eventName,
    data: { ...data, environment: process.env.NODE_ENV },
  });
};

const errorTrackEvent = (
  eventName: string,
  error: { message?: string; code?: unknown; status?: unknown },
  data: Record<string, unknown> = {}
): void => {
  trackEvent(eventName, {
    ...data,
    error: error.message,
    error_code: error?.code,
    error_status: error?.status,
    type: "error",
  });
};

export { initTracking, trackEvent, errorTrackEvent };
